import { formatDate, formatDateISO } from '@helpers/date';
import * as React from 'react';
import CardTags from '../CardTags/CardTags';
import TopicTags from '../TopicTags/TopicTags';
import S from './SearchResultCard.styles';
const SearchResultCard = (props) => {
    return (React.createElement(S.Container, { onClick: props.onClick },
        React.createElement(S.Inner, { href: props.url },
            React.createElement(CardTags, { idPrefix: props.id, tags: [
                    ...(props.formatTag ? [{ text: props.formatTag }] : []),
                    ...(props.sourceTags ? props.sourceTags : []),
                ] }),
            React.createElement(S.Name, null, props.name),
            props.date || props.author ? (React.createElement(S.Attributes, null,
                props.date ? (React.createElement("li", null,
                    React.createElement("time", { dateTime: formatDateISO(props.date) }, formatDate(props.date, 'd MMM yyyy')))) : null,
                props.author ? React.createElement("li", null, props.author) : null)) : null,
            React.createElement(S.Description, null, props.description),
            React.createElement(TopicTags, { idPrefix: props.id, tags: props.topicTags }))));
};
export default SearchResultCard;
